import { DateTime } from "luxon";
import { useApi } from "../api/useApi";
import Toaster, { ToastType } from "../common/Toaster";

export function useDistrictServiceDetails() {
  const api = useApi();

  return {
    downloadCSV: async ({
      school,
      start,
      end,
      onProgress,
    }: {
      school: { prefix: string };
      start: DateTime;
      end: DateTime;
      onProgress: (status: any) => void;
    }) => {
      try {
        const reader = await api.exports.districtServiceDetails.csv({
          schoolPrefix: school.prefix,
          startDate: start.toISO(),
          endDate: end.toISO(),
        });

        const decoder = new TextDecoder();
        let buffer = ""; // Add a buffer string

        while (true) {
          const { done, value } = await reader.read();
          if (done) break;

          // Append new chunk to the buffer
          buffer += decoder.decode(value, { stream: true });

          // Split by double newline (standard SSE separator)
          const messages = buffer.split("\n\n");

          // Keep the last (potentially incomplete) part in the buffer
          buffer = messages.pop() || "";

          for (const message of messages) {
            const line = message.trim();
            if (line.startsWith("data: ")) {
              try {
                const jsonString = line.replace("data: ", "");
                const payload = JSON.parse(jsonString);

                if (payload.status && payload.status !== 200) {
                  Toaster(payload.error, ToastType.error);
                  return false;
                }

                if (payload.complete) {
                  const fname =
                    `ssd_${school.prefix.toLowerCase().split(" ").join("_")}_` +
                    `${start.toISODate().replaceAll("-", "_")}_` +
                    `${end.toISODate().replaceAll("-", "_")}` +
                    ".csv";
                  onProgress({ file: fname, data: payload.data });
                } else {
                  onProgress(payload);
                }
              } catch (e) {
                console.error("Failed to parse JSON segment:", e);
              }
            }
          }
        }
        return true;
      } catch (e) {
        Toaster((e as Error).message, ToastType.error);
        return false;
      }
    },
  };
}
